import { CSSObject } from "@emotion/react";
import { constants } from "@newsela/angelou";

const { colors } = constants;

export const tabListCss: CSSObject = {
  display: "flex",
  borderBottom: `1px solid ${colors.ui.neutral[100]}`,
  gap: 4,
};

export const tabCss: CSSObject = {
  position: "relative",
  borderBottomRightRadius: 0,
  borderBottomLeftRadius: 0,

  "&[data-selected='true']": {
    fontWeight: "bold",

    "&:hover": {
      backgroundColor: "transparent",
    },

    "&:after": {
      content: '""',
      display: "block",
      position: "absolute",
      left: 0,
      bottom: 0,
      width: "100%",
      height: "2px",
      backgroundColor: colors.ui.core[700],
    },
  },
};
